import styled from 'styled-components';

export const TableWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const TopPagination = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;
